import React from 'react'
import { Grid } from '@material-ui/core'
import Post from './Post/Post'

const PostsByCate = ({ data }) => {
  return (
    <Grid className='container' container alignItems='stretch' spacing={3}>
      {data && data.length > 0
        ? data.map((post) => (
            <Grid key={post._id} item xs={6} md={3}>
              <Post post={post} />
            </Grid>
          ))
        : data.map((post) => (
            <Grid key={post._id} item xs={6} md={3}>
              <Post post={post} />
            </Grid>
          ))}
      {data.length > 0 ? (
        ''
      ) : (
        <p style={{ flexBasis: '100%', padding: '0px 20px', fontSize: '20px' }}>
          No files have been uploaded yet
        </p>
      )}
    </Grid>
  )
}

export default PostsByCate
